module.exports = "img/6.7c1c2a.webp";